module.exports = __webpack_public_path__ + "static/media/3p.71923fa6.jpg";